import { Component, EventEmitter, OnInit, Output, ViewChild, Inject, OnDestroy } from "@angular/core";
import { environment } from "../../../environments/environment";
import { StorageProxy } from "../../modules/common/service/storage-proxy.service";
import { Router, RouterModule } from "@angular/router";
import { User } from "../../modules/autenticacao/model/user";
import { AutenticacaoService } from "../../modules/common/service/autenticacao.service";
import { HubConnection, HubConnectionBuilder } from '@aspnet/signalr';
import * as signalR from '@aspnet/signalr';
import { Notificacao, NotificacaoTipo } from "../../modules/common/model/notificacao";
import { NotificacaoService } from "../../modules/common/service/notificacao.service";
import { FiltroNotificacao } from "../../modules/common/model/filtro-notificacao";
import { MatDialog, MatDialogModule } from "@angular/material/dialog";
import { MatMenu, MatMenuTrigger, MatMenuModule } from "@angular/material/menu";
import { DetalheNotificacaoComponent } from "../../modules/notificacao/detalhe-notificacao/detalhe-notificacao.component";
import { LayoutHeaderMenu, LayoutHeaderMenuType } from '../../common/model/header-menu';
import { WINDOW } from "../../common/providers/window.provider";
import { PreferenciasUsuarioModalComponent } from "../../modules/preferencias-usuario/preferencias-usuario-modal.component";
import { LanguageService } from "../../modules/common/service/language.service";
import { Credential } from "../../modules/autenticacao/model/credential";
import { PermissaoCarteira, PermissaoLista } from "../../modules/common/model/permissoes-usuario";
import { ConfigProvider } from "../../common/providers/config.provider";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatBadgeModule } from "@angular/material/badge";
import { TranslateModule, TranslatePipe, TranslateService } from "@ngx-translate/core";
import { FormsModule } from "@angular/forms";
import { ToggleOffcanvasNavDirective } from "../sidenav/toggle-offcanvas-nav.directive";
import { Subscription } from "rxjs";
import { Usuario } from "../../modules/common/model/usuario";
import { UsuarioService } from "../../modules/common/service/usuario.service";
import { LayoutEventsService } from "../../modules/common/service/layout-events.service";

// import { provideAnimations } from '@angular/platform-browser/animations';
// import { provideToastr } from 'ngx-toastr';
import { ToastrService } from 'ngx-toastr';
import { UsuarioTipoPipe } from "src/app/modules/common/pipes/usuario-tipo.pipe";

// import { ToastrModule } from 'ngx-toastr';
@Component({
	selector: "my-app-header",
	styleUrls: ["./header.component.scss"],
	templateUrl: "./header.component.html",
	standalone: true,
	imports: [
		CommonModule,
		RouterModule,
		MatDialogModule,
		MatMenuModule,
		MatButtonModule,
		MatIconModule,
		MatBadgeModule,
		TranslatePipe,
		FormsModule,
		UsuarioTipoPipe,
		ToggleOffcanvasNavDirective
	],
	providers: [
		{ provide: UsuarioService, useClass: UsuarioService }
	]
})

export class AppHeaderComponent implements OnInit, OnDestroy {

	LayoutHeaderMenuType = LayoutHeaderMenuType;

	public AppConfig: any;
	public usuario: User;
	public dadosUsuarioLogado: Usuario;
	public notificacao: Array<Notificacao> = new Array<Notificacao>();
	public notificacaoTipo = NotificacaoTipo;
	public novaNotificacao: boolean = false;
	public _hubConnection: HubConnection;
	public notificacaoTipoIcone: any = { "error": "cancel", "warning": "warning", "info": "info" };
	logo: string = 'talkmaestro'
	public menusContexto: Array<LayoutHeaderMenu> = [];
	idiomaSelecionado;
	idiomas;

	notificacoesNaoLidas: any;
	subOnLoginChange: Subscription;


	public get aaa() {
		return this.notificacoesNaoLidas.todos > 0;
	}


	@ViewChild(MatMenu, { static: true }) appHeaderMenu: MatMenu;
	@ViewChild(MatMenuTrigger, { static: true }) matHeaderMenuTrigger: MatMenuTrigger;

	@ViewChild(MatMenu, { static: true }) appNotificationMenu: MatMenu;
	@ViewChild(MatMenuTrigger, { static: true }) matNotificationMenuTrigger: MatMenuTrigger;

	@Output() menuClosed: EventEmitter<void>;


	constructor(private router: Router,
		private dialog: MatDialog,
		private autenticacaoService: AutenticacaoService,
		private usuarioService: UsuarioService,
		private layoutEventsService: LayoutEventsService,
		private notificacaoService: NotificacaoService,
		private toastr: ToastrService,
		private languageService: LanguageService,
		private translate: TranslateService,
		private configProvider: ConfigProvider,
		@Inject(WINDOW) private window: Window
	) {

		this.idiomas = this.languageService.idiomas;
		this.idiomaSelecionado = this.languageService.getLanguage();

		if (this.window.location.hostname.includes('.teajudei'))
			this.logo = 'teajudei';

		if (this.window.location.hostname.includes('.epbx'))
			this.logo = 'talkmaestro';

		if (this.window.location.hostname.includes('.brbots'))
			this.logo = 'brbots';

		this.subOnLoginChange = this.layoutEventsService.onLoginChange.subscribe((result: any) => {
			this.usuarioService.meuUsuario().subscribe((usr: Usuario) => {
				this.dadosUsuarioLogado = usr;
				let title = this.translate.instant('header.alteracaoConta');  //Alteração da conta 
				let msg = this.translate.instant('header.alteracaoContaMsg'); //Logado na conta Talkcomm
				this.toastr.success(`${msg} ${this.dadosUsuarioLogado.conta.nome}`, title, { 'timeOut': 7000, 'extendedTimeOut': 1000, 'progressBar': true, 'progressAnimation': 'decreasing' });
			});
		});
	}

	ngOnInit() {
		this.AppConfig = environment;
		this.usuario = StorageProxy.get<Credential>('userData').user;
		this.menusContexto = this.getHeaderContextMenus();
		this.notificacaoService.obterNotificacao(new FiltroNotificacao()).subscribe(notificacao => (this.notificacao = [] /*notificacao*/));
		this.obterQuantidadeHistoricoNaoLido();

		this.usuarioService.meuUsuario().subscribe((usr: Usuario) => {
			this.dadosUsuarioLogado = usr;			
		});
	}

	ngOnDestroy(): void {
		if (this.subOnLoginChange)
			this.subOnLoginChange.unsubscribe();
	}

	public get obterNomeUsuario() {
		this.usuario = StorageProxy.get<Credential>('userData').user;
		return this.usuario.userName;
	}

	toggleCollapsedNav() {
		this.AppConfig.navCollapsed = !this.AppConfig.navCollapsed;
	}

	notificacoes() {
		this.router.navigate(["app/notificacao"]);
	}

	possuiPermissaoNotificacao(notificacao: Notificacao): boolean {
		let carteiras = StorageProxy.get<Array<PermissaoCarteira>>('carteiras')
		let listas = StorageProxy.get<Array<PermissaoLista>>('listas')
		var permissaoLista = listas.length == 0 || notificacao.listaId == null || listas.some(l => l.listaId == notificacao.listaId);
		var permissaoCarteira = carteiras.some(c => c.carteiraId == notificacao.carteiraId);
		return permissaoLista && permissaoCarteira;
	}

	obterQuantidadeHistoricoNaoLido() {

		this.notificacaoService.obterQuantidadeHistoricoNaoLido().subscribe((result: any[]) => {
			this.notificacoesNaoLidas = result;//.map((m:any) => m as number);
		});
	}

	setLanguage(linguagem) {
		this.languageService.setLanguage(linguagem.codigo);
		this.idiomaSelecionado = linguagem;
		window.location.reload();
	}

	getHeaderContextMenus(): Array<LayoutHeaderMenu> {
		if (this.autenticacaoService.autenticado) {
			return [
				//{ "name": "login.alterarSenha", "rota": 'alterarsenha', "acao": null },
				{ "name": "header.perfil", "type": LayoutHeaderMenuType.Menu, "icone": "fa-user-o", "rota": null, "class": null, "acao": () => { this.perfil(); } },
				{ "name": "header.preferenciasUsuario", "type": LayoutHeaderMenuType.Menu, "icone": "fa-wrench", "rota": null, "class": null, "acao": () => { this.modalPreferenciasUsuario(); } },
				{ "type": LayoutHeaderMenuType.Divisoria },
				{ "name": "header.sair", "type": LayoutHeaderMenuType.Menu, "icone": "fa-power-off", "rota": null, "class": 'danger', "acao": () => { this.sair(); } }
			];
		} else {
			return [];
		}
	}

	modalPreferenciasUsuario() {

		const preferenciasUsuarioRef = this.dialog.open(PreferenciasUsuarioModalComponent, {
			hasBackdrop: true,
			width: "800px",
			data: {}
		});

		preferenciasUsuarioRef.afterClosed().subscribe(() => { });
	}

	sair() {
		this.autenticacaoService.logoutUser().subscribe();
		this.router.navigate(["/login"]);
	}

	perfil() {
		this.router.navigate(["app/perfil"]);
	}
}
